import {load} from '@shopify/theme-sections';
import '../sections/product-template';

load('*');
